<div id="unAuthModalContainer" class="-oneX-modal__container" style="display:none" data-disabled-scrim>
    <div class="-oneX-modal-content " aria-labelledby="unAuthModalHeading" role="dialog" style="text-align: center;">
        <div id="unAuthModalHeading" class="-oneX-modal-heading " role="heading" aria-level="2" tabindex="-1">Unauthorized</div>
        <div class="-oneX-modal-body">Please login to access this resource</div>
        <div class="-oneX-modal-footer">
            <div class="-oneX-row">
                <div class="-oneX-modal-primary__div -oneX-col">
                    <a role="button" href="{{b2bHome}}" onclick="oneX.Modal.hideModal()" class="-oneX-btn-secondary__anchor">Back to B2B</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="forbiddenModalContainer" class="-oneX-modal__container" style="display:none" data-disabled-scrim>
    <div class="-oneX-modal-content" aria-labelledby="forbiddenModalHeading" role="dialog" style="text-align: center;">
        <div id="forbiddenModalHeading" class="-oneX-modal-heading" role="heading" aria-level="2" tabindex="-1">
            Forbidden
        </div>
        <div class="-oneX-modal-body">
            You don't have the correct permissions to access this resource. Please contact B2B front desk to have the correct role. 
        </div>
        <div class="-oneX-modal-footer">
            <div class="-oneX-row">
                <div class="-oneX-modal-primary__div -oneX-col">
                    <a role="button" href="{{b2bHome}}" onclick="oneX.Modal.hideModal()" class="-oneX-btn-secondary__anchor">Back to B2B</a>
                </div>
            </div>
        </div>
    </div>
</div>